var dux = {};
dux.query = jQuery.noConflict();
require( 'vendor/modernizr' );
require( 'collapse' );
require( 'dropdown' );
require( 'modalizer' );
require( 'notifier' );
require( 'responsive-tabs' );
require( 'tooltip' );
require( 'popover' );
require( 'sticky-th' );
require( 'toastr' );
require( 'resource-scroll' );
require( 'file-input' );
require( 'color-code' );
require( 'item-list' );
require( 'text-input-cancel' );